import { Injectable, inject } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import { lastValueFrom } from 'rxjs';
import {
  SOFTLINE_API_GARAGE_ORDER_PRINT,
  SOFTLINE_API_GARAGE_ROSTER_PRINT,
} from '../garage.api';

@Injectable()
export class PrintRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  async retrieve(id: number, start: string, end: string): Promise<string> {
    const result = await lastValueFrom(
      this.#dataAccess.download(
        {
          path: SOFTLINE_API_GARAGE_ROSTER_PRINT,
          pathParams: { id },
        },
        { start, end }
      )
    );
    if (result && result.type === 'response' && result.response) {
      return URL.createObjectURL(
        result.response instanceof Blob ? result.response : new Blob([result.response])
      );
    }

    return '';
  }

  async retrieve2(type: string, id: number): Promise<string> {
    const result = await lastValueFrom(
      this.#dataAccess.download(
        {
          path: SOFTLINE_API_GARAGE_ORDER_PRINT,
          pathParams: { id },
        },
        { type }
      )
    );
    if (result && result.type === 'response' && result.response) {
      return URL.createObjectURL(
        result.response instanceof Blob ? result.response : new Blob([result.response])
      );
    }

    return '';
  }
}
